module.exports = __webpack_public_path__ + "img/phone.e33b0840.png";